import { ArrowRight } from "lucide-react";
import { Reveal, scrollToWaitlist } from "@/components/landing/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Attention is not formation.",
    body: "Social platforms bury ministry content under algorithmic distraction, then monetize attention with ads. Discipleship was never meant to compete for engagement.",
  },
  {
    n: "02",
    title: "There is no home built for faith.",
    body: "Christian communities have never had a platform of their own. They borrow space on tools built for everyone, where faith is treated as just another customer segment and discovery places their communities beside content that contradicts their values. What is missing is a dedicated home, built for Christian community.",
  },
  {
    n: "03",
    title: "The cost falls on the wrong people.",
    body: "Custom church apps cost tens of thousands. Platform fees price out the campus leader and the small ministry, the very people doing the most disciple-making.",
  },
];

export const WhyExists = () => (
  <section id="why" className="relative py-16 md:py-24 bg-ink text-sage overflow-hidden">
    <div className="pointer-events-none absolute top-0 right-0 w-[30rem] h-[30rem] rounded-full bg-green-dark/20 blur-3xl" />
    <div className="max-w-6xl mx-auto px-6 md:px-12 relative">
      <Reveal>
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-green mb-4">
          Why This Exists
        </p>
        <h2 className="font-serif text-4xl md:text-6xl tracking-tight max-w-3xl text-balance">
          Everyone Built Content Apps. Nobody Built For Formation.
        </h2>
      </Reveal>

      <div className="mt-16 md:mt-20 divide-y divide-sage/15">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.05}>
            <div className="grid md:grid-cols-12 gap-6 md:gap-10 py-10 md:py-14 items-start">
              <div className="md:col-span-3">
                <span className="font-serif text-6xl md:text-7xl text-plum/90 leading-none">
                  {c.n}
                </span>
              </div>
              <div className="md:col-span-9">
                <h3 className="font-serif text-2xl md:text-3xl mb-4">{c.title}</h3>
                <p className="text-base md:text-lg text-sage/75 leading-relaxed max-w-2xl">
                  {c.body}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-14 md:mt-20 max-w-3xl">
          <p className="font-serif italic text-2xl md:text-3xl leading-relaxed text-sage">
            The people called to build Christian community deserve a platform
            that shares their convictions, not one that treats faith as an
            afterthought.
          </p>
          <button
            onClick={scrollToWaitlist}
            data-testid="why-waitlist-btn"
            className="group mt-10 inline-flex items-center gap-2 rounded-full bg-sage px-8 py-4 text-base font-semibold text-ink hover:bg-green hover:text-white transition-colors duration-300"
          >
            Join the waitlist
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2} />
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
